import './App.css';
import Body from './components/Body';
import Homepage from './components/Homepage';
import 'animate.css';


function App() {
  return (
    <div className="App">
      {/* <Header></Header> */}
      <Homepage></Homepage>
      <Body></Body>
    </div>
  );
}

export default App;
